import type { SVGProps } from 'react';

const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 18"
    {...props}
  >
    <rect width={24} height={18} fill="transparent" rx={4} />
    <path
      fill="currentColor"
      d="M18.667 3.667H5.34l-.007 10.666h13.334zM17.333 13H6.667V9h10.666zm0-6.667H6.667V5h10.666z"
    />
  </svg>
);
export default SvgCreditCard;
